<template lang="pug">
  .columns
    .column.is-4
      label Fecha: {{ fechaBD }}
      .field
        .control
          input.input.is-black(type='text' :placeholder="fechaBD" v-model="nominacion" :disabled="isDisabled")
    .column.is-4(v-show="mostrar_Save")
      a.button(:class="guardado" :disabled="isDisabled" @click="saveNominacion") Guardar Nominaci&oacute;n
    .column.is-4(v-show="mostrar_Edit")
      a.button.is-warning(@click="editarNominacion") Editar Nominaci&oacute;n
      | &nbsp
      a.button.is-danger(@click="eliminarNominacion")
        span.icon
          i.fas.fa-trash
    .column.is-4(v-show="mostrar_Update")
      a.button.is-info(@click="updateNominacion") Actualizar Nominaci&oacute;n
      | &nbsp
      a.button.is-dark(@click="cancelUpdateNominacion") Cancelar
</template>

<script>
  import nominaciones_tpaServices from '@/services/sca/nominaciones/nominacionesTpa.js'
  import moment from 'moment'
  import { mapState } from 'vuex'

  export default {
    name: 'Inputfecha',
    props: {
      data: {
        type: Object,
        default: () => {}
      },
      enabledList: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        idBD: '',
        fechaBD: '',
        grupoBD: '',
        nominacion: 0,
        nominacionBD: '',
        isDisabled: false,
        guardado: 'is-black',
        mostrar_Update: false,
        mostrar_Save: false,
        mostrar_Edit: false
      }
    },
    watch: {
      data() {
        this.rellenarData()
      }
    },
    methods: {
      saveNominacion () {
        if (this.permisos.sca_tpa > 1) {
          return
        }
        if (!this.isDisabled) {
          let id = Date.now()
          nominaciones_tpaServices.guardarNom_Diaria(id, this.grupoBD, this.nominacion, this.fechaBD)
            .then( r => {
                this.isDisabled = true
                this.guardado = ''
                this.mostrar_Edit = true
                this.mostrar_Save = false
                this.displayToast(r.respuesta, r.success ? 'check' : 'ban', 'OK')
            })
            .catch(e => {
              this.isLoading = false
              this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
            })
        }
      },
      editarNominacion () {
        if (this.permisos.sca_tpa > 1) {
          return
        }
        this.mostrar_Edit = false
        this.mostrar_Update = true
        this.isDisabled = false
      },

      eliminarNominacion () {
        if (this.permisos.sca_tpa > 1) {
          return
        }
        this.nominacion = 0
        nominaciones_tpaServices.updateNewNominacion(this.grupoBD, this.nominacion, this.fechaBD)
          .then(res => {
            if (res.success) {
              let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
              nominaciones_tpaServices.guardarCambioNominacion(this.grupoBD, 0, this.nominacion, this.userLogin.id, this.userLogin.nombre, fechaReg)
                .then( r => {
                  this.displayToast(r.respuesta, r.success ? 'check' : 'ban', 'OK')
                  this.$emit('updateNominaciones', true)
                  this.cancelUpdateNominacion()
                })
                .catch(e => {
                  this.isLoading = false
                  this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
                })

            } else {
              this.displayToast(`Error: ${res.respuesta}`, 'ban', 'OK')
            }
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
      },

      updateNominacion () {
        if (this.permisos.sca_tpa > 1) {
          return
        }
        nominaciones_tpaServices.updateNewNominacion(this.grupoBD,this.nominacion, this.fechaBD)
          .then(res => {
            if (res.success) {
              let fechaReg = moment().format('YYYY-MM-DD HH:mm:ss')
              nominaciones_tpaServices.guardarCambioNominacion(this.grupoBD, this.nominacionBD, this.nominacion, this.userLogin.id, this.userLogin.nombre, fechaReg)
                .then( r => {
                  this.displayToast(r.respuesta, r.success ? 'check' : 'ban', 'OK')
                  this.cancelUpdateNominacion()
                })
                .catch(e => {
                  this.isLoading = false
                  this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
                })

            } else {
              this.displayToast(`Error: ${res.respuesta}`, 'ban', 'OK')
            }
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
      },

      cancelUpdateNominacion() {
        this.mostrar_Update = false
        this.mostrar_Edit = true
        this.guardado = 'is-black'
        this.isDisabled = true
      },
      rellenarData () {
        this.fechaBD = this.data.fecha
        this.grupoBD = this.data.grupo
        this.nominacionBD = this.data.nominacion
        this.nominacion = this.nominacionBD
        this.idBD = this.data.id
        this.enabled = this.enabledForList
        this.isDisabled = this.data.inBD

        if (this.data.inBD) {
          this.mostrar_Edit = true
          this.mostrar_Save = false
        } else {
          this.mostrar_Save = true
          this.guardado = 'is-black'
          this.mostrar_Edit = false
        }
      },
      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : null,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      }
    },
    created () {
      this.rellenarData()
    },
    computed: {
      ...mapState(['logueado', 'userLogin', 'permisos'])
    }
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/nominaciones/componentes/InputFecha.vue